import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const API = environment.url_login;

@Injectable({
  providedIn: 'root'
})
export class ResetSenhaService {

  constructor(private http:HttpClient) { 

   }
   
   enviarPassword(data) {
     
    return this.http.post(API + '/auth/forgetPassword', data);
  }
}
